'use strict';
var ContentService = /** @class */ (function () {
    /*@ngInject*/
    function ContentService($http) {
        this._$http = $http;
    }
    /*@ngInject*/
    ContentService.prototype.getContent = function (id) {
        var request = this._$http({
            method: "get",
            url: "api/content/" + id
        });
        return request.then(function (data) {
            return data;
        }, function () { return {}; });
    };
    /*@ngInject*/
    ContentService.prototype.getShipping = function () {
        return this.getContent(9004);
    };
    /*@ngInject*/
    ContentService.prototype.getEQP = function () {
        return this.getContent(9005);
    };
    /*@ngInject*/
    ContentService.prototype.getSupport = function () {
        return this.getContent(9006);
    };
    return ContentService;
}());
export default ContentService;
//# sourceMappingURL=content.service.js.map